import { LoginLayout, PasswordForgot } from "features/login";
import { useCheckLoginStatus } from "Hooks";
export const ForgotPassword = () => {
  useCheckLoginStatus();

  return <LoginLayout form={<PasswordForgot />} animateLogo={false} />;
};
